// <drag-scroll> — enables mouse/pen drag-to-scroll on a child overflow element.
// Touch is ignored so native touch scrolling is preserved.
const DRAG_THRESHOLD_PX = 5;
if (!customElements.get('drag-scroll')) {
  class DragScroll extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.media-thumbs');
      if (!this.scroller) return;

      this.isDown = false;
      this.dragged = false;
      this.startX = 0;
      this.startScroll = 0;

      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);

      this.scroller.addEventListener('pointerdown', this.onPointerDown);
    }

    disconnectedCallback() {
      if (this.scroller) {
        this.scroller.removeEventListener('pointerdown', this.onPointerDown);
      }
      this.endDrag();
    }

    onPointerDown(evt) {
      // Touch already scrolls natively — only handle mouse/pen.
      if (evt.pointerType === 'touch') return;
      this.isDown = true;
      this.dragged = false;
      this.startX = evt.clientX;
      this.startScroll = this.scroller.scrollLeft;
      // Track the drag via document listeners. setPointerCapture is
      // intentionally NOT used: it retargets the follow-up click event to
      // the scroller, which breaks thumbnail selection in media-gallery.js.
      document.addEventListener('pointermove', this.onPointerMove);
      document.addEventListener('pointerup', this.onPointerUp);
      document.addEventListener('pointercancel', this.onPointerUp);
    }

    onPointerMove(evt) {
      if (!this.isDown) return;
      const delta = evt.clientX - this.startX;
      if (Math.abs(delta) > DRAG_THRESHOLD_PX) {
        this.dragged = true;
        this.scroller.classList.add('is-dragging');
      }
      this.scroller.scrollLeft = this.startScroll - delta;
    }

    onPointerUp() {
      if (!this.isDown) return;
      this.endDrag();

      if (this.dragged) {
        // Suppress the click that follows a drag so a thumbnail is not
        // selected by accident. Capture phase fires before media-gallery.js.
        const suppress = (clickEvt) => clickEvt.stopPropagation();
        this.addEventListener('click', suppress, true);
        setTimeout(() => this.removeEventListener('click', suppress, true), 0);
      }
    }

    endDrag() {
      this.isDown = false;
      if (this.scroller) this.scroller.classList.remove('is-dragging');
      document.removeEventListener('pointermove', this.onPointerMove);
      document.removeEventListener('pointerup', this.onPointerUp);
      document.removeEventListener('pointercancel', this.onPointerUp);
    }
  }

  customElements.define('drag-scroll', DragScroll);
}
